import { contractStates } from '../../../constants';
import FilterTranslatorConverter from '../FilterTranslatorConverter';
const filterTranslator = {
  [contractStates.scheduled]: () => ({
    type: 'comparison',
    field: 'data/contractStartDate',
    value: new Date().getTime(),
    comparator: '>',
    empty: false,
    isDate: true
  }),
  [contractStates.active]: () => ({
    type: 'logical',
    operator: 'or',
    conditions: [{
      type: 'logical',
      operator: 'and',
      conditions: [{
        type: 'comparison',
        field: 'data/contractStartDate',
        value: new Date().getTime(),
        comparator: '<=',
        empty: false,
        isDate: true
      }, {
        type: 'comparison',
        field: 'data/contractEndDate',
        value: new Date().getTime(),
        comparator: '>=',
        empty: false,
        isDate: true
      }]
    }, {
      type: 'logical',
      operator: 'and',
      conditions: [{
        type: 'comparison',
        field: 'data/contractStartDate',
        value: new Date().getTime(),
        comparator: '<=',
        empty: false,
        isDate: true
      }, {
        type: 'exists',
        field: 'data/contractEndDate',
        not: true
      }]
    }]
  }),
  [contractStates.archived]: () => ({
    type: 'comparison',
    field: 'data/contractEndDate',
    value: new Date().getTime(),
    comparator: '<',
    empty: false,
    isDate: true
  })
};
export default FilterTranslatorConverter.create('companyContract.calculatedContractState', filterTranslator);